import React, { useState } from "react";
import { useRecoilState } from "recoil";
import { Box, Link } from "@mui/material";
import DownloadIcon from "@iconify/icons-mdi/download";
import ShowIcon from "@iconify/icons-mdi/show";
import { InlineIcon } from "@iconify/react";
import { myDocumentsIsDocument } from "my-documents/states/is-document-state";
import { myDocumentsShowDocument } from "my-documents/states/show-document-state";
import { MyHrAttachmentDialog } from "my-hr/components";

interface DocumentProps {
  filename: string;
  slug: string;
}

export const MyDocumentsActionCell = ({
  document,
  isMobile,
}: {
  document: DocumentProps;
  isMobile: boolean;
}) => {
  const [fullScreenVisible, setFullScreenVisible] = useRecoilState(
    myDocumentsShowDocument,
  );
  const [, /*isDocuments*/ setIsDocuments] = useRecoilState(
    myDocumentsIsDocument,
  );
  const [selectedFile, setSelectedFile] = useState<DocumentProps | null>(null);

  const getFileExtension = (filename: string) => {
    return (filename.split(".").pop() || "").toLowerCase();
  };

  const fileExtension = getFileExtension(document?.filename);

  const allowedExtensions = ["pdf", "jpeg", "png", "jpg"];

  const handleCancel = () => {
    setFullScreenVisible(false);
    setSelectedFile(null);
  };

  const handleShowFile = () => {
    const isPdf = document?.slug.toLowerCase().endsWith(".pdf");
    if (isPdf) {
      window.open(document?.slug, "_blank");
      setIsDocuments(true);
    } else {
      setSelectedFile(document);
      setFullScreenVisible(true);
    }
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="flex-end"
      paddingRight={isMobile ? "0px" : "15px"}
    >
      <Box display="flex" alignItems="center">
        {allowedExtensions?.includes(fileExtension) && (
          <Box>
            <InlineIcon
              id="showIcon"
              icon={ShowIcon}
              width="24px"
              style={{
                color: "#919699",
                cursor: "pointer",
                display: "flex",
              }}
              onClick={handleShowFile}
            />
            {selectedFile && (
              <MyHrAttachmentDialog
                showDialog={fullScreenVisible}
                handleCancel={handleCancel}
                fileData={selectedFile}
                pdfSize={
                  selectedFile
                    ? getFileExtension(selectedFile.filename) === "pdf"
                    : undefined
                }
              />
            )}
          </Box>
        )}
        <Box width="8px" />
        <Link
          href={document?.slug}
          target={document?.slug}
          download={document?.filename}
        >
          <InlineIcon
            id="downloadIcon"
            icon={DownloadIcon}
            width="24px"
            style={{
              color: "#919699",
              cursor: "pointer",
              display: "flex",
            }}
            onClick={() => setIsDocuments(true)}
          />
        </Link>
      </Box>
    </Box>
  );
};

export default MyDocumentsActionCell;
